const isNotUndefined = <Value extends unknown>(value: Value | undefined): value is Value => value !== undefined;
export const filterOutUndefinedValues = <Value extends unknown>(array: (Value | undefined)[]): Value[] => {
  return array.filter(isNotUndefined);
};
